export const EQUIPMENT_MODEL_RELATIONS = {
  'relations[0]': 'author',
  'relations[1]': 'status',
};

export const buildEquipmentModelRelationParams = () => ({
  ...EQUIPMENT_MODEL_RELATIONS,
});

export const getEquipmentModelStatusLabel = (row) =>
  row?.status?.name ?? row?.status?.label ?? row?.status_name ?? '—';

export const getEquipmentModelAuthorLabel = (row) =>
  row?.author?.name ?? row?.author?.username ?? '—';

export const formatEquipmentModelDate = (value) => {
  if (!value) return '—';
  const raw = String(value).trim();
  if (!raw) return '—';
  const parsed = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T'));
  if (Number.isNaN(parsed.getTime())) return raw;
  return parsed.toLocaleString();
};

export const buildEquipmentModelFormData = (values) => {
  const formData = new FormData();
  formData.append('status_id', String(values.status_id ?? ''));
  formData.append('name', values.name ?? '');
  formData.append('description', values.description ?? '');
  return formData;
};
